import {
  Editor,
  Transforms,
  Node,
  Path
} from 'slate';
import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import HelptapEditor from '../';

export function getDefaultOptions() {

  return basicEditorValueSerializer.utilities.node.directory.getDefaultOptions();

}

export function buildNode(collectionId) {

  return basicEditorValueSerializer.utilities.node.directory.buildNode(collectionId);

}

export function select(editor, path) {

  const node = Node.get(editor, path);

  const lastChildPath = [...path, node.children.length - 1];

  Transforms.select(editor, lastChildPath);
  Transforms.collapse(editor, { edge: 'end' });

}

export function insert(editor, path, collectionId) {

  const node = buildNode(collectionId);

  HelptapEditor.replaceNode(editor, Path.parent(path), node);
}

export function toggle(editor) {

  const nodeOptions = buildNode();

  HelptapEditor.setNodeOptions(editor, nodeOptions);

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}

export function replace(editor, path) {

  Editor.withoutNormalizing(editor, () => {

    Transforms.removeNodes(editor, { at: path });
    insert(editor, path);

  });

}

export function initialize(editor, node, nodePath, data) {

  HelptapEditor.setAttributes(editor, {
    properties: {
      ...node.properties,
      ...data
    }
  }, nodePath);

}

export function isDirectoryNode(node) {

  return node.type === basicEditorValueSerializer.allTypes.types.DIRECTORY;

}